var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"shrink",attrs:{"alt":"Company logo","contain":"","src":_vm.white
      ? require('../assets/logo-white.png')
      : require('../assets/logo.png'),"transition":"scale-transition"}})
}
var staticRenderFns = []

export { render, staticRenderFns }